import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { supportedLngs } from '../../utils/ConstCapture';

export const Route = createFileRoute('/$lang')({
  beforeLoad: ({ params }) => {
    if (!supportedLngs.includes(params.lang)) {
      throw redirect({
        to: '/$lang/workstations',
        params: { lang: 'es' },
      });
    }
  },
  component: () => <Outlet />,
});
